<template>
  <Modal
    v-model="visible"
    :title="modalTitle"
    :mask-closable="false"
    width="620"
    @on-cancel="handleCancel"
  >
    <Form
      v-if="visible"
      ref="formRef"
      :model="formData"
      :label-width="110"
      class="task-form"
    >
      <FormItem
        label="任务名称"
        prop="activityName"
        :rules="[
          { required: true, message: '请输入任务名称', trigger: 'blur' }
        ]"
      >
        <Input
          v-model.trim="formData.activityName"
          :maxlength="100"
          placeholder="请输入任务名称"
        />
      </FormItem>

      <FormItem
        label="任务类型"
        prop="activityType"
        :rules="[
          {
            required: true,
            type: 'number',
            message: '请选择任务类型',
            trigger: 'change'
          }
        ]"
      >
        <Select
          v-model="formData.activityType"
          placeholder="请选择任务类型"
          @on-change="handleTypeChange"
        >
          <Option
            v-for="item in typeOptions"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          >
            {{ item.label }}
          </Option>
        </Select>
      </FormItem>
      
      <template v-if="useLegacyDailyForm">
        <FormItem label="展示人群" v-if="showLegacyCrowdFields">
          <RadioGroup
            v-model="formData.crowdLimit"
            type="button"
            button-style="solid"
            @on-change="handleCrowdLimitChange"
          >
            <Radio :label="0">不限</Radio>
            <Radio :label="1">选择人群包</Radio>
          </RadioGroup>
      </FormItem>
      <FormItem
          v-if="showLegacyCrowdFields && formData.crowdLimit === 1"
          label="人群包"
          prop="crowdIds"
          :rules="[
            {
              required: true,
              type: 'array',
              min: 1,
              message: '请选择人群包',
              trigger: 'change'
            }
          ]"
        >
          <Select
            v-model="formData.crowdIds"
            multiple
            filterable
            clearable
            :max-tag-count="1"
            placeholder="请选择人群包"
          >
            <Option
              v-for="item in crowdOptions"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            >
              {{ item.name }}
            </Option>
          </Select>
      </FormItem>
        <FormItem
          label="排序值"
          prop="activitySort"
          :rules="[
            {
              required: true,
              type: 'number',
              message: '请输入排序值',
              trigger: 'change'
            }
          ]"
        >
          <InputNumber
            v-model="formData.activitySort"
            :min="0"
            :max="999999"
            :precision="0"
            style="width: 180px"
          />
        </FormItem>

        <FormItem
          v-if="!isUpdateTask"
          label="广告次数限制"
          prop="adsLimit"
          :rules="[
            {
              required: true,
              type: 'number',
              message: '请输入广告次数限制',
              trigger: 'change'
            }
          ]"
        >
          <InputNumber
            v-model="formData.adsLimit"
            :min="0"
            :max="999999"
            :precision="0"
            style="width: 180px"
          />
        </FormItem>

        <FormItem
          v-if="!isUpdateTask"
          label="可完成次数"
          prop="availableLimit"
          :rules="[
            {
              required: true,
              type: 'number',
              message: '请选择可完成次数',
              trigger: 'change'
            }
          ]"
        >
          <Select
            v-model="formData.availableLimit"
            placeholder="请选择可完成次数"
          >
            <Option
              v-for="item in availableLimitOptions"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
              {{ item.label }}
            </Option>
          </Select>
        </FormItem>

        <FormItem
          label="赠送金币"
          prop="bonusCoins"
          :rules="[
            {
              required: true,
              type: 'number',
              message: '请输入赠送金币',
              trigger: 'change'
            }
          ]"
        >
          <InputNumber
            v-model="formData.bonusCoins"
            :min="0"
            :max="999999"
            :precision="0"
            style="width: 180px"
          />
        </FormItem>
      </template>

      <template v-else>
        <FormItem
          v-if="showTaskPageUrl"
          label="跳转页面"
          prop="taskPageUrl"
          :rules="[
            { required: true, message: '请输入跳转页面', trigger: 'blur' }
          ]"
        >
          <Input
            v-model.trim="formData.taskPageUrl"
            placeholder="请输入跳转页面"
            :maxlength="500"
          />
        </FormItem>

        <FormItem
          v-if="showH5RemainTime"
          label="H5停留时长"
          prop="h5RemainTime"
          :rules="[
            {
              required: true,
              type: 'number',
              message: '请输入H5停留时长',
              trigger: 'change'
            }
          ]"
        >
          <div class="inline-row">
            <InputNumber
              v-model="formData.h5RemainTime"
              :min="1"
              :max="9999"
              :precision="0"
              style="width: 160px"
            />
            <span class="inline-unit">秒</span>
          </div>
        </FormItem>

        <FormItem label="展示人群">
          <RadioGroup
            v-model="formData.crowdLimit"
            type="button"
            button-style="solid"
            @on-change="handleCrowdLimitChange"
          >
            <Radio :label="0">不限</Radio>
            <Radio :label="1">选择人群包</Radio>
          </RadioGroup>
        </FormItem>

        <FormItem
          v-if="formData.crowdLimit === 1"
          label="人群包"
          prop="crowdIds"
          :rules="[
            {
              required: true,
              type: 'array',
              min: 1,
              message: '请选择人群包',
              trigger: 'change'
            }
          ]"
        >
          <Select
            v-model="formData.crowdIds"
            multiple
            filterable
            clearable
            :max-tag-count="1"
            placeholder="请选择人群包"
          >
            <Option
              v-for="item in crowdOptions"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            >
              {{ item.name }}
            </Option>
          </Select>
        </FormItem>

        <FormItem
          label="排序值"
          prop="activitySort"
          :rules="[
            {
              required: true,
              type: 'number',
              message: '请输入排序值',
              trigger: 'change'
            }
          ]"
        >
          <InputNumber
            v-model="formData.activitySort"
            :min="0"
            :max="999999"
            :precision="0"
            style="width: 180px"
          />
        </FormItem>

        <FormItem
          label="广告次数限制"
          prop="adsLimit"
          :rules="[
            {
              required: true,
              type: 'number',
              message: '请输入广告次数限制',
              trigger: 'change'
            }
          ]"
        >
          <InputNumber
            v-model="formData.adsLimit"
            :min="0"
            :max="999999"
            :precision="0"
            style="width: 180px"
          />
        </FormItem>

        <FormItem
          label="可完成次数"
          prop="availableLimit"
          :rules="[
            {
              required: true,
              type: 'number',
              message: '请选择可完成次数',
              trigger: 'change'
            }
          ]"
        >
          <Select
            v-model="formData.availableLimit"
            placeholder="请选择可完成次数"
          >
            <Option
              v-for="item in availableLimitOptions"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
              {{ item.label }}
            </Option>
          </Select>
        </FormItem>

        <FormItem
          label="赠送金币"
          prop="bonusCoins"
          :rules="[
            {
              required: true,
              type: 'number',
              message: '请输入赠送金币',
              trigger: 'change'
            }
          ]"
        >
          <InputNumber
            v-model="formData.bonusCoins"
            :min="0"
            :max="999999"
            :precision="0"
            style="width: 180px"
          />
        </FormItem>

        <FormItem label="状态">
          <i-switch
            v-model="formData.activityStatus"
            :true-value="1"
            :false-value="0"
          />
        </FormItem>
      </template>
    </Form>

    <template #footer>
      <Button @click="handleCancel">取消</Button>
      <Button type="primary" :loading="loading" @click="handleSubmit">
        {{ formData.id ? '保存' : '新增' }}
      </Button>
    </template>
  </Modal>
</template>

<script>
import { addActivity, editActivity } from '@/api/activity'
import {
  AVAILABLE_LIMIT_OPTIONS,
  TASK_CATEGORY_DAILY,
  TASK_CATEGORY_NEW_USER,
  getTaskTypeOptionsByCategory,
  inferTaskCategoryByType
} from '../constants'

const createDefaultForm = (taskCategory) => ({
  id: '',
  activityName: '',
  activityType: undefined,
  crowdLimit: 0,
  crowdIds: [],
  activitySort: 0,
  adsLimit: 0,
  availableLimit: 0,
  bonusCoins: 0,
  activityStatus: 1,
  h5RemainTime: 15,
  taskPageUrl: '',
  relatedPushId: null,
  taskCategory: Number(taskCategory)
})

const SPECIAL_DAILY_TASK_TYPES = [14, 15]

export default {
  name: 'TaskModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    },
    crowdOptions: {
      type: Array,
      default: () => []
    },
    taskCategory: {
      type: Number,
      default: TASK_CATEGORY_DAILY
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      formData: createDefaultForm(this.taskCategory),
      availableLimitOptions: AVAILABLE_LIMIT_OPTIONS
    }
  },
  computed: {
    isDailyTask() {
      return Number(this.formData.taskCategory) === TASK_CATEGORY_DAILY
    },
    isSpecialDailyTask() {
      return SPECIAL_DAILY_TASK_TYPES.includes(Number(this.formData.activityType))
    },
    useLegacyDailyForm() {
      return this.isDailyTask && !this.isSpecialDailyTask
    },
    showLegacyCrowdFields() {
      return this.useLegacyDailyForm && Number(this.formData.activityType) === 6
    },
    isUpdateTask() {
      return Number(this.formData.activityType) === 12
    },
    typeOptions() {
      return getTaskTypeOptionsByCategory(this.taskCategory)
    },
    showTaskPageUrl() {
      return Number(this.formData.activityType) === 15
    },
    showH5RemainTime() {
      return Number(this.formData.activityType) === 14
    },
    modalTitle() {
      if (Number(this.formData.activityType) === 15) {
        return this.formData.id ? '编辑评分任务' : '评分任务配置'
      }
      if (Number(this.formData.activityType) === 14) {
        return this.formData.id ? '编辑H5任务' : 'H5任务配置'
      }
      if (this.isDailyTask) {
        return this.formData.id ? '编辑活动' : '新增活动'
      }
      return this.formData.id ? '编辑新用户任务' : '新任务配置'
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.visible = val
        if (val) {
          this.mapDataToForm(this.data)
        }
      }
    },
    visible(val) {
      this.$emit('input', val)
    },
    taskCategory() {
      if (this.visible) {
        this.mapDataToForm(this.data)
      }
    }
  },
  methods: {
    isSpecialDailyTaskType(activityType) {
      return SPECIAL_DAILY_TASK_TYPES.includes(Number(activityType))
    },
    resolveTaskCategory(source) {
      const hasActivityType = source.activityType === 0 || source.activityType
      const fallbackTaskCategory =
        source.taskCategory === TASK_CATEGORY_DAILY ||
        source.taskCategory === TASK_CATEGORY_NEW_USER
          ? Number(source.taskCategory)
          : this.taskCategory

      if (!hasActivityType) return fallbackTaskCategory

      return inferTaskCategoryByType(source.activityType, fallbackTaskCategory)
    },
    mapDataToForm(data) {
      const base = createDefaultForm(this.taskCategory)
      const source = data || {}
      const activityType =
        source.activityType === 0 || source.activityType
          ? Number(source.activityType)
          : undefined

      this.formData = {
        ...base,
        ...source,
        taskCategory: this.resolveTaskCategory(source),
        activityStatus:
          source.activityStatus === 0 || source.activityStatus === 1
            ? Number(source.activityStatus)
            : base.activityStatus,
        crowdLimit:
          source.crowdLimit === 0 || source.crowdLimit === 1
            ? Number(source.crowdLimit)
            : base.crowdLimit,
        crowdIds: Array.isArray(source.crowdIds) ? [...source.crowdIds] : [],
        activityType,
        activitySort:
          source.activitySort === 0 || source.activitySort
            ? Number(source.activitySort)
            : base.activitySort,
        adsLimit:
          source.adsLimit === 0 || source.adsLimit
            ? Number(source.adsLimit)
            : base.adsLimit,
        availableLimit:
          source.availableLimit === 0 ||
          source.availableLimit === 1 ||
          source.availableLimit === -1
            ? Number(source.availableLimit)
            : base.availableLimit,
        bonusCoins:
          source.bonusCoins === 0 || source.bonusCoins
            ? Number(source.bonusCoins)
            : base.bonusCoins,
        h5RemainTime:
          source.h5RemainTime === 0 || source.h5RemainTime
            ? Number(source.h5RemainTime)
            : base.h5RemainTime,
        taskPageUrl: source.taskPageUrl || '',
        relatedPushId:
          source.relatedPushId === 0 || source.relatedPushId
            ? Number(source.relatedPushId)
            : null
      }
    },
    handleTypeChange(value) {
      const nextType = Number(value)

      if (this.isDailyTask && !this.isSpecialDailyTaskType(nextType)) {
        this.formData.crowdLimit = 0
        this.formData.crowdIds = []
        this.formData.h5RemainTime = 15
        this.formData.taskPageUrl = ''
        this.formData.relatedPushId = null
        this.formData.adsLimit = 0

        if (nextType === 12) {
          this.formData.availableLimit = -1
        } else if (Number(this.formData.availableLimit) === -1) {
          this.formData.availableLimit = 0
        }
        return
      }

      if (Number(this.formData.availableLimit) === -1) {
        this.formData.availableLimit = 0
      }
      if (nextType !== 14) {
        this.formData.h5RemainTime = 15
      }
      if (nextType !== 15) {
        this.formData.taskPageUrl = ''
        this.formData.relatedPushId = null
      }
    },
    handleCrowdLimitChange(value) {
      if (Number(value) === 0) {
        this.formData.crowdIds = []
      }
    },
    buildSubmitPayload() {
      const payload = {
        id: this.formData.id || undefined,
        activityName: this.formData.activityName,
        activityType: Number(this.formData.activityType),
        activitySort: Number(this.formData.activitySort || 0),
        adsLimit: Number(this.formData.adsLimit || 0),
        availableLimit: Number(this.formData.availableLimit),
        bonusCoins: Number(this.formData.bonusCoins || 0),
        taskCategory: Number(this.formData.taskCategory),
        activityStatus: Number(this.formData.activityStatus)
      }

      if (this.useLegacyDailyForm) {
        payload.crowdLimit = this.showLegacyCrowdFields
          ? Number(this.formData.crowdLimit)
          : 0
        payload.crowdIds =
          this.showLegacyCrowdFields && Number(this.formData.crowdLimit) === 1
            ? [...this.formData.crowdIds]
            : []
        if (Number(this.formData.activityType) === 12) {
          payload.availableLimit = -1
          payload.adsLimit = 0
        }
      } else {
        payload.crowdLimit = Number(this.formData.crowdLimit)
        payload.crowdIds =
          Number(this.formData.crowdLimit) === 1
            ? [...this.formData.crowdIds]
            : []

        if (this.showH5RemainTime) {
          payload.h5RemainTime = Number(this.formData.h5RemainTime || 0)
        }

        if (this.showTaskPageUrl) {
          payload.taskPageUrl = this.formData.taskPageUrl
          if (
            this.formData.relatedPushId === 0 ||
            this.formData.relatedPushId
          ) {
            payload.relatedPushId = Number(this.formData.relatedPushId)
          }
        }
      }

      if (!payload.id) {
        delete payload.id
      }

      return payload
    },
    handleCancel() {
      this.visible = false
    },
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return

        if (!this.useLegacyDailyForm && this.showH5RemainTime) {
          if (Number(this.formData.h5RemainTime) <= 0) {
            this.$Message.error('请输入有效的H5停留时长')
            return
          }
        }

        this.loading = true
        try {
          const payload = this.buildSubmitPayload()
          const request = this.formData.id
            ? editActivity(payload)
            : addActivity(payload)
          await request
          this.$Message.success('保存成功')
          this.visible = false
          this.$emit('on-success')
        } catch (error) {
          this.$Message.error('保存失败')
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.task-form {
  padding-right: 12px;
}

.inline-row {
  display: flex;
  align-items: center;
}

.inline-unit {
  margin-left: 8px;
  color: #808695;
}
</style>
